import { MarketViewSettingsActiveMarketViewTypesEnum } from "@eu.mdotm.api/sphere";
import market_view_custom from "$root/assets/images/create-dialog[preload]/market-view-custom.svg";
import market_view_expected from "$root/assets/images/create-dialog[preload]/market-view-expected.svg";
import market_view_under from "$root/assets/images/create-dialog[preload]/market-view-under.svg";
import { typedUrlForRoute } from "$root/components/PlatformRouter/RoutesDef";
import { marketViewRepository } from "$root/functional-areas/market-view/repository";
import type { SpawnResult } from "@mdotm/shadcn/legacy/react-extensions";
import {
	type MultipleChoiceCreationDialogItem,
	spawnMultipleChoiceCreationDialog,
} from "./MultipleChoiceCreationDialog";

export async function spawnMarketViewCreationDialog({ intentId }: { intentId?: string }): Promise<SpawnResult<void>> {
	const marketViewSettings = await marketViewRepository.marketViewSettings.fetchQuery();
	const activeMarketViewTypes = marketViewSettings.activeMarketViewTypes;
	if (!activeMarketViewTypes?.length) {
		throw new Error("no available market view type");
	}

	return spawnMultipleChoiceCreationDialog({
		options: (
			[
				[
					MarketViewSettingsActiveMarketViewTypesEnum.ExpectedReturnsVolatility,
					{
						href: typedUrlForRoute("MarketViewWorkSpace/New", {
							type: MarketViewSettingsActiveMarketViewTypesEnum.ExpectedReturnsVolatility,
							intentId,
						}),
						"data-qualifier": "PortfolioStudio/MarketViewList/NewMarketView/ExpectedReturns",
						icon: market_view_expected,
						title: "Expected returns",
						description: "Set your market view regimes.",
					},
				],
				[
					MarketViewSettingsActiveMarketViewTypesEnum.PositioningIndicators,
					{
						href: typedUrlForRoute("MarketViewWorkSpace/New", {
							type: MarketViewSettingsActiveMarketViewTypesEnum.PositioningIndicators,
							intentId,
						}),
						icon: market_view_under,
						"data-qualifier": "PortfolioStudio/MarketViewList/NewMarketView/UnderOverWeight",
						title: "Under / over weight",
						description: "Set your market view positioning.",
					},
				],
				[
					MarketViewSettingsActiveMarketViewTypesEnum.Custom,
					{
						href: typedUrlForRoute("MarketViewWorkSpace/New", {
							type: marketViewSettings.customMarketViewType!,
							isCustom: "true",
							intentId,
						}),
						icon: market_view_custom,
						"data-qualifier": "PortfolioStudio/MarketViewList/NewMarketView/Custom",
						title: marketViewSettings.customMarketViewName ?? "Custom",
						description: "Set your custom market view.",
					},
				],
			] as const
		).flatMap(([type, option]) => (activeMarketViewTypes.includes(type) ? [option] : [])) as [
			MultipleChoiceCreationDialogItem,
			...MultipleChoiceCreationDialogItem[],
		] /* guaranteed by `if` above */,
	});
}
